<template>
  <message-form
    v-if="showView"
    message-type="forward"
    :predefined-subject="subject"
    :predefined-body="body"
    :predefined-attachments="attachments"
    :predefined-to="to"
    :predefined-from="from"
    @route-change="routeName => $emit('route-change', routeName)"
  />
</template>

<script>
import MessageForm from '@/components/forms/MessageForm'
import { format } from 'date-fns'

export default {
  name: 'Forward',

  components: {
    MessageForm
  },

  props: {
    messageId: {
      type: String,
      default: '',
      required: true
    },

    mailboxType: {
      type: String,
      default: '',
      required: true
    },

    setCursorInBody: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      subject: '',
      body: '',
      attachments: [],
      to: [],
      from: {},
      sentDate: '',
      showView: false
    }
  },

  async created () {
    this.$store.dispatch('findAndSetHelpObject', {
      id: 68,
      isInitial: true
    })

    try {
      const { subject, body, to, from, date, attachments } = await this.$store.dispatch('messages/getMessage', {
        messageId: this.messageId,
        mailboxType: this.mailboxType,
        setCursorInBody: this.setCursorInBody
      })

      this.to = to
      this.from = from
      this.sentDate = date
      this.subject = `FW: ${subject}`
      this.attachments = attachments

      this.body = `

      ---------- Forwarded message ---------
      From: ${from.firstName} ${from.lastName} <${from.email}>
      Date: ${format(new Date(date), 'yyyy-MM-dd HH:mm:ss')}
      Subject: ${subject}
      To: ${to.map(({ email }) => email).join(', ')}

      ${body}`.replace(/  +/g, '')

      this.showView = true
    } catch (error) {
      this.$store.commit('snackbar/update',
        {
          type: 'error',
          message: 'Failed to get message'
        }
      )

      this.$store.dispatch('logError', {
        error,
        fileName: 'Messages > Forward',
        functionName: 'created'
      })
    }
  }
}
</script>
